import React, { useState, useEffect, useRef, useCallback } from "react";
import { Text } from "components";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import pdfMake from "pdfmake/build/pdfmake";
import { MdDelete } from "react-icons/md";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Swal from "sweetalert2";
import Breadcrumb from "components/Breadcrumb/Breadcrumb";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function CreditNoteItemList() {
  const [taxinvoiceitem, setTaxinvoiceItem] = useState([]);
  const [loading, setLoading] = useState(true); // State for loading indicator
  const gridRef = useRef();
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const tax_invoice_id = location.state?.tax_invoice_id;
  console.log(tax_invoice_id);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 59 && item.update
  );

  useEffect(() => {
    getAllTaxInvoiceItems();
  }, []);

  const obj = { credit_note_id: id };
  const getAllTaxInvoiceItems = () => {
    axios
      .post("/api/purple-fusion/creditnoteitem/get", obj, headers)
      .then((response) => {
        setTaxinvoiceItem(response.data);
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderCellValue = (params) => {
    const value = params.value;
    return value === null ? "NA" : value;
  };

  const onHandleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      html: `You want to delete 
      <span style="color: #FF5733;"></span>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .put("/api/purple-fusion/creditnoteitem/update", { id: id }, headers)
          .then((response) => {
            console.log(response.data);
            const message = response.data.message;
            if (response.data.status) {
              toast.success(message, {
                autoClose: 1000,
              });
              getAllTaxInvoiceItems();
            } else {
              toast.error(message, {
                autoClose: 1000,
              });
            }
          });
      }
    });
  };

  const sortedtaxinvoiceitem = taxinvoiceitem
    .slice()
    .sort((a, b) => b.id - a.id);

  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "landscape",
      header: {
        text: "Tax Invoice Items",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "SR.NO", style: "tableHeader", bold: true }],
                [{ text: "CREDIT NOTE", style: "tableHeader", bold: true }],
                [{ text: "ITEM  ", style: "tableHeader", bold: true }],
                [{ text: "Code ", style: "tableHeader", bold: true }],
                [
                  {
                    text: "ITEM DESCRIPTION ",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "HSN CODE", style: "tableHeader", bold: true }],
                [{ text: "SAC CODE", style: "tableHeader", bold: true }],
                [{ text: "DELIVERY DATE", style: "tableHeader", bold: true }],
                [{ text: "QUANTITY", style: "tableHeader", bold: true }],
                [{ text: "COST PRICE ", style: "tableHeader", bold: true }],
                [{ text: "ITEM AMOUNT ", style: "tableHeader", bold: true }],
                [
                  {
                    text: "SGST %  ",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "CGST %  ",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "IGST %  ",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "SGST AMOUNT  ", style: "tableHeader", bold: true }],
                [{ text: "CGST AMOUNT  ", style: "tableHeader", bold: true }],
                [{ text: "IGST AMOUNT  ", style: "tableHeader", bold: true }],
                [{ text: "TOTAL TAX  ", style: "tableHeader", bold: true }],
                [{ text: "TOTAL AMOUNT  ", style: "tableHeader", bold: true }],
                [{ text: "ACTIVE", style: "tableHeader", bold: true }],

                [{ text: "CREATED DATE", style: "tableHeader", bold: true }],
              ],
              ...taxinvoiceitem.map((taxinvoiceitem, index) => [
                index + 1,
                taxinvoiceitem.taxinvoicecode,
                taxinvoiceitem.itemname,
                taxinvoiceitem.code_op,
                taxinvoiceitem.item_description,
                taxinvoiceitem.hsn_code,
                taxinvoiceitem.sac_code,
                taxinvoiceitem.delivery_date,
                taxinvoiceitem.quantity,
                taxinvoiceitem.cost_price,
                taxinvoiceitem.item_amount,
                taxinvoiceitem.sgst_percentage,
                taxinvoiceitem.cgst_percentage,
                taxinvoiceitem.igst_percentage,
                taxinvoiceitem.sgst_amount,
                taxinvoiceitem.cgst_amount,
                taxinvoiceitem.igst_amount,
                taxinvoiceitem.total_tax,
                taxinvoiceitem.total_amount,
                taxinvoiceitem.isactive ? "Yes" : "No",
                // salesOrder.createdby,
                taxinvoiceitem.createdon.substr(0, 10),
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 6, // Set the font size to a smaller value
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 8, // You can set a different font size for headers if needed
          color: "#000",
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
          // Add underline
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download("Tax Invoice Item List");
  };

  const onBtnExport = useCallback(() => {
    const columnsToExport = [
      "sr",
      "taxinvoicecode",
      "itemname",
      "item_description",
      "hsn_code",
      "sac_code",
      "quantity",
      "cost_price",
      "item_amount",
      "sgst_percentage",
      "cgst_percentage",
      "igst_percentage",
      "sgst_amount",
      "cgst_amount",
      "igst_amount",
      "total_tax",
      "total_amount",
      "createdon",
      "isactive",
    ]; // Replace with your actual column field

    const exportColumns = customColDefs.filter((column) =>
      columnsToExport.includes(column.field)
    );
    const options = {
      fileName: "Tax Invoice Item List.csv", // Specify your desired filename here
      columnKeys: exportColumns.map((column) => column.field), // Specify the column field to export
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const defaultColDefs = [
    { headerName: "Sr.No.", field: "sr", width: 85 },
    // { headerName: "Company ID", field: "company_id", width: 150 },
    { headerName: "CREDIT NOTE", field: "fin_credit_note_code", width: 150 },
    { headerName: "ITEM", field: "itemname", width: 150 },
    { headerName: " PROVIDED CODE", field: "code_op", width: 150 },
    { headerName: "CODE", field: "code", width: 150 },
    { headerName: "PACKAGING", field: "packaging", width: 150 },

    {
      headerName: "HSN CODE",
      field: "hsn_code",
      width: 130,
      valueFormatter: renderCellValue,
    },
    {
      headerName: "SAC CODE",
      field: "sac_code",
      width: 130,
      valueFormatter: renderCellValue,
    },
    { headerName: "QUANTITY", field: "quantity", width: 130 },
    { headerName: "COST PRICE", field: "cost_price", width: 130 },
    { headerName: "ITEM AMOUNT", field: "item_amount", width: 150 },
    { headerName: "SGST %", field: "sgst_percentage", width: 100 },
    { headerName: "CGST %", field: "cgst_percentage", width: 100 },
    { headerName: "IGST % ", field: "igst_percentage", width: 100 },
    { headerName: "SGST AMOUNT", field: "sgst_amount", width: 150 },
    { headerName: "CGST AMOUNT", field: "cgst_amount", width: 150 },
    { headerName: "IGST AMOUNT", field: "igst_amount", width: 150 },
    { headerName: "TOTAL TAX", field: "total_tax", width: 150 },
    { headerName: "TOTAL AMOUNT", field: "total_amount", width: 150 },
    { headerName: "ITEM DESCRPTION", field: "item_description", width: 150 },
    {
      headerName: "ACTIVE",
      field: "isactive",
      width: 100,
      valueFormatter: (params) => {
        return params.value ? "Yes" : "No";
      },
    },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      width: 120,
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
    },
  ];
  const customColDefs = [
    ...defaultColDefs,
    {
      headerName: "",
      field: "id",
      width: 50,
      filter: false,
      pinned: "right",
      cellRenderer: (params) => (
        <button
          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          onClick={() => {
            onHandleDelete(params.value);
          }}
        >
          <MdDelete className="text-base" />
        </button>
      ),
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(showActionColumn ? customColDefs : defaultColDefs);
  }, [showActionColumn]);
  const ColDefaultVale = { filter: true };

  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };

  return (
    <>
      {erplist.some((item) => item.erp_module_id === 59 && item.view) ? (
        <div className="overflow-hidden">
          <ToastContainer />
          <div className="flex  flex-row w-full items-center my-3">
            {/* <div>
              {" "}
              <div>
                <Text
                  className="text-base md:text-[22px]  text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] "
                  size="txtInterSemiBold24"
                >
                  {" "}
                  <div className="flex flex-row items-center ">
                    <div
                      className="hover:cursor-pointer whitespace-nowrap text-center underline"
                      onClick={() => navigate("/creditdebitnoteAll")}
                    >
                      Credit Note
                    </div>

                    <div className="whitespace-nowrap px-1 ">/</div>
                    <div className="whitespace-nowrap ">Items</div>
                  </div>
                </Text>
              </div>
            </div> */}
            <Breadcrumb
              items={[
                { label: "Credit-Note", path: "/creditdebitnoteAll" },
                { label: "Items" }, // Current page, no path
              ]}
            />
            <div className="flex text-3xl relative flex-row justify-end items-center font-inter gap-2 px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white ml-12">
              <div className="flex flex-col relative">
                <button
                  onClick={() => setDownload(!download)}
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-2 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <button
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={DownloadPDF}
                      >
                        PDF
                      </button>
                    </li>
                    <li>
                      <button
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex flex-col items-center justify-center">
                {erplist.some(
                  (item) => item.erp_module_id === 30 && item.add
                ) && (
                  <button
                    type="button"
                    id="dropdownDefaultButton"
                    className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                    onClick={() => {
                      navigate(`/creditNote/item/add/${id}`, {
                        state: {
                          tax_invoice_id: tax_invoice_id,
                        },
                      });
                    }}
                  >
                    + Add
                  </button>
                )}
              </div>
              {/* </Link> */}
            </div>
          </div>

          <div className="ag-theme-quartz" id="my-table">
            <AgGridReact
              ref={gridRef}
              rowData={sortedtaxinvoiceitem.map((taxinvoiceitem, index) => ({
                ...taxinvoiceitem,
                sr: index + 1,
              }))}
              columnDefs={colDefs}
              pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              // gridOptions={gridOptions}
              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default CreditNoteItemList;
